import {DetailsFieldsGrid} from '@/components/ui/details-atoms/DetailsAtoms'
import styled, {css} from 'styled-components'

export const StyledDetailsFieldsGrid = styled(DetailsFieldsGrid)(
    ({theme: {palette, spacing}}) => css`
        grid-template-columns: 1fr 2fr 1fr;
        & > div {
            border-bottom: 1px solid ${palette.neutral[200]};
            padding-bottom: ${spacing * 2}px;
        }
    `
)
